// import React, { useState } from "react";

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phoneNumber: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const botToken = "7568123400:AAGa0zAIZnM1NbNjawsfDnQMM9Fao2VvbJM";
//     const chatId = "1385285165";
//     const text = `
//       📨 Yangi xabar!  
//       👤 Ism: ${formData.firstName}  
//       👤 Familiya: ${formData.lastName}  
//       📧 Email: ${formData.email}  
//       📱 Telefon: ${formData.phoneNumber}  
//       💬 Xabar: ${formData.message}  
//     `;

//     const url = `https://api.telegram.org/bot${botToken}/sendMessage`;

//     try {
//       await fetch(url, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ chat_id: chatId, text }),
//       });
//       alert("Xabaringiz yuborildi!");
//       setFormData({ firstName: "", lastName: "", email: "", phoneNumber: "", message: "" });
//     } catch (error) {
//       alert("Xatolik yuz berdi!");
//     }
//   };

//   return (
//     <section>
//       <div className="isolate bg-slate-900 px-6 py-24 sm:py-32 lg:px-8">
//         <div className="absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]" aria-hidden="true">
//           <div className="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]" />
//         </div>
//         <div className="mx-auto max-w-2xl text-center">
//           <h2 className="text-4xl font-semibold tracking-tight text-white sm:text-5xl">Biz bilan bog'laning</h2>
//           <p className="mt-2 text-lg text-white font-sans">Savollaringiz yoki takliflaringiz bo'lsa, biz bilan bog'laning!</p>
//         </div>
//         <form onSubmit={handleSubmit} className="mx-auto mt-16 max-w-xl sm:mt-20">
//           <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
//             <div>
//               <label htmlFor="firstName" className="block text-sm font-semibold text-white">Ismingiz</label>
//               <div className="mt-2.5">
//                 <input type="text" name="firstName" id="firstName" value={formData.firstName} onChange={handleChange} className="block w-full rounded-md px-3.5 py-2 text-gray-900 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600" placeholder="Ismingizni kiriting" required />
//               </div>
//             </div>
//             <div>
//               <label htmlFor="lastName" className="block text-sm font-semibold text-white">Familiyangiz</label>
//               <div className="mt-2.5">
//                 <input type="text" name="lastName" id="lastName" value={formData.lastName} onChange={handleChange} className="block w-full rounded-md px-3.5 py-2 text-gray-900 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600" placeholder="Familiyangizni kiriting" required />
//               </div>
//             </div>
//             <div className="sm:col-span-2">
//               <label htmlFor="email" className="block text-sm font-semibold text-white">Email</label>
//               <div className="mt-2.5">
//                 <input type="email" name="email" id="email" value={formData.email} onChange={handleChange} className="block w-full rounded-md px-3.5 py-2 text-gray-900 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600" placeholder="Emailingizni kiriting" required />
//               </div>
//             </div>
//             <div className="sm:col-span-2">
//               <label htmlFor="phoneNumber" className="block text-sm font-semibold text-white">Telefon raqamingiz</label>
//               <div className="mt-2.5">
//                 <input type="text" name="phoneNumber" id="phoneNumber" value={formData.phoneNumber} onChange={handleChange} className="block w-full rounded-md px-3.5 py-2 text-gray-900 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600" placeholder="+998 XX XXX XX XX" required />
//               </div>
//             </div>
//             <div className="sm:col-span-2">
//               <label htmlFor="message" className="block text-sm font-semibold text-white">Xabaringiz</label>
//               <div className="mt-2.5">
//                 <textarea name="message" id="message" rows="4" value={formData.message} onChange={handleChange} className="block w-full rounded-md px-3.5 py-2 text-gray-900 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600" placeholder="Xabaringizni yozing" required></textarea>
//               </div>
//             </div>
//           </div>
//           <div className="mt-10">
//             <button type="submit" className="block w-full rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-600">
//               Yuborish
//             </button>
//           </div>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default Contact;


import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const botToken = "7568123400:AAGa0zAIZnM1NbNjawsfDnQMM9Fao2VvbJM";
    const chatId = "1385285165";
    const text = `
      📨 Yangi xabar!  
      👤 Ism: ${formData.firstName}  
      👤 Familiya: ${formData.lastName}  
      📧 Email: ${formData.email}  
      📱 Telefon: ${formData.phoneNumber}  
      💬 Xabar: ${formData.message}  
    `;

    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;

    try {
      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: chatId, text }),
      });
      alert("Xabaringiz yuborildi!");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        message: "",
      });
    } catch (error) {
      alert("Xatolik yuz berdi!");
    }
  };

  return (
    <section>
      <div className="isolate bg-slate-900 px-6 py-24 sm:py-32 lg:px-8">
        <div
          className="absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]"
          aria-hidden="true"
        >
          <div className="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]" />
        </div>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-semibold tracking-tight text-white sm:text-5xl">
            Biz bilan bog'laning
          </h2>
          <p className="mt-2 text-lg text-white font-sans">
            Savollaringiz yoki takliflaringiz bo'lsa, biz bilan bog'laning!
          </p>
        </div>
        <form
          onSubmit={handleSubmit}
          className="mx-auto mt-16 max-w-xl sm:mt-20"
        >
          <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
            <div>
              <label
                htmlFor="firstName"
                className="block text-sm font-semibold text-white"
              >
                Ismingiz
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="firstName"
                  id="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="block w-full rounded-md px-3.5 py-2 text-gray-900 bg-blue-100 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600"
                  placeholder="Ismingizni kiriting"
                  required
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="lastName"
                className="block text-sm font-semibold text-white"
              >
                Familiyangiz
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="lastName"
                  id="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="block w-full rounded-md px-3.5 py-2 text-gray-900 bg-blue-100 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600"
                  placeholder="Familiyangizni kiriting"
                  required
                />
              </div>
            </div>
            <div className="sm:col-span-2">
              <label
                htmlFor="email"
                className="block text-sm font-semibold text-white"
              >
                Email
              </label>
              <div className="mt-2.5">
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="block w-full rounded-md px-3.5 py-2 text-gray-900 bg-blue-100 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600"
                  placeholder="Emailingizni kiriting"
                  required
                />
              </div>
            </div>
            <div className="sm:col-span-2">
              <label
                htmlFor="phoneNumber"
                className="block text-sm font-semibold text-white"
              >
                Telefon raqamingiz
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="phoneNumber"
                  id="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="block w-full rounded-md px-3.5 py-2 text-gray-900 bg-blue-100 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600"
                  placeholder="+998 XX XXX XX XX"
                  required
                />
              </div>
            </div>
            <div className="sm:col-span-2">
              <label
                htmlFor="message"
                className="block text-sm font-semibold text-white"
              >
                Xabaringiz
              </label>
              <div className="mt-2.5">
                <textarea
                  name="message"
                  id="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  className="block w-full rounded-md px-3.5 py-2 text-gray-900 bg-blue-100 outline-none placeholder-gray-400 focus:ring-2 focus:ring-indigo-600"
                  placeholder="Xabaringizni yozing"
                  required
                ></textarea>
              </div>
            </div>
          </div>
          <div className="mt-10">
            <button
              type="submit"
              className="block w-full rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-600"
            >
              Yuborish
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;

